import { Component, Input, ViewChild } from '@angular/core';
import { appNavItem } from '../app-nav/app-nav.component';

@Component({
  selector: 'am-app-nav-submenu',
  template: `
    <mat-menu #subMenu="matMenu" role="menu">
      <ng-container *ngFor="let item of items">
        <!-- Handle main menu items -->
        <ng-container *ngIf="item.items">
          <button
            [routerLink]="item.route ? item.route : []"
            mat-menu-item
            [matMenuTriggerFor]="menu.subMenu"
          >
            {{ item.label }}
          </button>
          <am-app-nav-submenu #menu [items]="item.items"></am-app-nav-submenu>
        </ng-container>
        <!-- Handle sub menu items -->
        <ng-container *ngIf="!item.items">
          <button mat-menu-item [routerLink]="item.route" role="link">
            {{ item.label }}
          </button>
        </ng-container>
      </ng-container>
    </mat-menu>
  `,
})
export class AppNavSubmenuComponent {
  @Input() items: appNavItem[];
  @ViewChild('subMenu', { static: true }) public subMenu;
}
